import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import AllnewsContainer from "../news/containers/allnewscontainer.component";
import Comments from '../../../SHARED/components/comments/comments.component';
import NewsAuthor from '../../../SHARED/components/newsauthor/newsauthor.component';
import NewsAuthorBiography from './containers/newsauthorbiography.component';
import { API_URL } from "../../../SHARED/config/apiEndpoints";
import {getNewsDetails, addNewsToFavorite, removeNewsFromFavorite, addNewsComment} from '../../../SHARED/actions/news.actions';
import Spinner from '../../../SHARED/components/spinner/spinner.component';
import {withRouter} from 'react-router';
import {LOGIN_ROUTE} from "../../../SHARED/config/routes";
import ModalShare from "../../../SHARED/components/modalsharing/modalshare.component";
import Helmet from "react-helmet";
import Parser from "html-react-parser";
import SearchByTag from '../../../SHARED/components/searchbytag/searchbytag.component';
import {pageViewEvent, slugify} from "../../../SHARED/helpers/general.helper";
import FilterButton from "../../../SHARED/components/filterbutton/filterbutton.component";
import {Link} from "react-router-dom";
import NewsRecommendedForYou from "../newsrecommendedforyou/newsrecommendedforyou.component";
import ReactPlayer from 'react-player';
import Ads from "../ads/ads.component";
import postscribe from "postscribe";
import { getFormattedTextForMeta } from '../../../SHARED/helpers/general.helper';
class NewsDetails extends Component {

    constructor(props){
        super(props);
        this.state = {
            isAuthenticated: false,
            isFavorite: false,
            openShareModal: false,
            pageIsCompletelyLoaded: false,
            lastEventTitle: null,
        }
        this.toggle = this.toggle.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        window.scrollTo(0, 0);
        if (nextProps.match.params.id !== this.props.match.params.id) {
            window.scrollTo(0, 0);
            this.props.history.push(nextProps.location.pathname);
            this.props.getNewsDetails(nextProps.match.params.id);
            if (this.el.children.length > 0) {
                const emptyDiv = document.createElement('div');
                emptyDiv.id = 'ads-video-script';
                emptyDiv.className = 'ads-video-script';
                const children = this.el.children;
                for (let i = 0; i < children.length; i++) {
                    if (i == 3){
                        children[i].appendChild(emptyDiv);
                    }
                }
                postscribe('#ads-video-script', '<script async src=\'https://www.googletagservices.com/tag/js/gpt.js\'>\n' +
                    '  googletag.pubads().definePassback(\'/95005615/cinemap_intext\', [580, 400]).display();\n' +
                    '</script>');
            }
        }
        if (this.el.children.length > 0) {
            const emptyDiv = document.createElement('div');
            emptyDiv.id = 'ads-video-script';
            emptyDiv.className = 'ads-video-script';
            const children = this.el.children;
            if(children.length > 3) {
                for (let i = 0; i < children.length; i++) {
                    if (i == 3) {
                        children[i].appendChild(emptyDiv);
                    }
                }
            } else {
                for (let i = 0; i < children.length; i++) {
                    if (i == 0) {
                        children[i].appendChild(emptyDiv);
                    }
                }
            }
            postscribe('#ads-video-script', '<script async src=\'https://www.googletagservices.com/tag/js/gpt.js\'>\n' +
                '  googletag.pubads().definePassback(\'/95005615/cinemap_intext\', [580, 400]).display();\n' +
                '</script>');
        }

    }

    componentWillMount(){
        const articleId = this.props.match.params.id;
        this.props.getNewsDetails(articleId);
        this.isUserAuthenticated();
        window.prerenderReady = false;
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        window.addEventListener('load', this.handleLoad);
     }

     componentDidUpdate(){
        if(this.props.newsDetails.article_title && this.props.newsDetails.article_title !==this.state.lastEventTitle){
            pageViewEvent(this.props.newsDetails.article_title, window.location.href)
            this.setState({lastEventTitle:this.props.newsDetails.article_title})
        }
     }
     handleLoad = () => {
        this.setState({
            pageIsCompletelyLoaded: true
        });
        window.prerenderReady = true;
     }

    isUserAuthenticated = () => {
        if (localStorage.getItem('login_type') === 'authenticated'){
            this.setState({isAuthenticated : true});
        }
    };

    getTags = () =>{
        if (this.props.newsDetails.article_tags !== undefined) {
            return this.props.newsDetails.article_tags.map((tag, i) => {
                return (
                    <Link to={'/tag/' + slugify(tag.title) } key={i}>
                        <FilterButton interactivity={true} appearance={'styled'} label={tag.title} id={tag.id} />
                    </Link>
                );
            })
        }
    };

    getAuthorName = () => {
        if(this.props.newsDetails.article_author_first_name && this.props.newsDetails.article_author_last_name) {
            return this.props.newsDetails.article_author_first_name + " " + this.props.newsDetails.article_author_last_name;
        }
    };

    addNewsToFavorite = () => {
        if(this.state.isAuthenticated) {
            this.props.addNewsToFavorite(this.props.newsDetails.article_uuid);
        } else {
            this.props.history.push(LOGIN_ROUTE)
        }
    };

    removeNewsFromFavorite = () => {
        if(this.state.isAuthenticated) {
            this.props.removeNewsFromFavorite(this.props.newsDetails.favorite[0].uuid);
        } else {
            this.props.history.push(LOGIN_ROUTE)
        }

    };

    getFavoriteNews = () => {
        this.props.getFavoriteNews();
    };

    isFavorite = () => {
        if (this.props.newsDetails.favorite !== undefined)
        {
            return (this.props.newsDetails.favorite.length !== 0) ?
                <Fragment>
                <span className="news-details-favorite-active" onClick={this.removeNewsFromFavorite} />
                <span className="share-mov" onClick={this.toggle} />
                </Fragment> :
                <Fragment>
                <span className="news-details-favorite" onClick={this.addNewsToFavorite} />
                <span className="share-mov" onClick={this.toggle} />
                </Fragment>
        }
    };

    addComment = (data) => {
        if (this.state.isAuthenticated){
            const body = {
                "article_id": this.props.newsDetails.article_id,
                "comment": data.comment
            };
            this.props.addNewsComment(body);
        } else {
            this.props.history.push(LOGIN_ROUTE);
        }
    };

    toggle = () => {
        this.setState({openShareModal: !this.state.openShareModal});
    };

    getAds() {
        return (
            window.innerWidth > 1400 ? 
             <Ads
                 id="div-gpt-ad-1662463178982-0"
                 slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463178982-0'); googletag.pubads().refresh();});"
             /> : 
             <Ads
                 id="div-gpt-ad-1662463706379-0"
                 slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463706379-0'); googletag.pubads().refresh();});"
             />
        );
        // if (this.props.newsDetails.article_category && this.props.newsDetails.article_category === "Star Wars") {
        //     return (
        //         <Ads
        //             id="div-gpt-ad-1662463178982-0"
        //             slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463178982-0'); });"
        //         />
        //     );
        // }
        // if (this.props.newsDetails.article_category && this.props.newsDetails.article_category !== "Star Wars") {
        //     return (
        //         <Ads
        //             id="div-gpt-ad-1662463314968-0"
        //             slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463314968-0'); });"
        //         />
        //     );
        // }
    }
    render() {
        console.log(this.props)
        return (
            <Fragment>
                <div className="container-fluid news-details">
                    <Helmet>
                        <title>{ getFormattedTextForMeta(this.props.newsDetails.article_title, 0) }</title>
                        <meta name="description" content={this.props.newsDetails.article_body && getFormattedTextForMeta(this.props.newsDetails.article_body, 1)}/>
                        <link rel="canonical" href={window.location.href}/>

                        <meta property="og:url"                content={window.location.href} />
                        <meta property="og:type"               content="article" />
                        <meta property="og:title"              content={this.props.newsDetails.article_title ? Parser(this.props.newsDetails.article_title) : ""} />
                        <meta property="og:description"        content={this.props.newsDetails.article_body && getFormattedTextForMeta(this.props.newsDetails.article_body, 1)} />
                        <meta property="og:image"              content={API_URL + this.props.newsDetails.article_image} />
                        <meta property="og:image:width"        content="200" />
                        <meta property="og:image:height"       content="500" />

                        <meta name="twitter:card" content="summary" />
                        <meta name="twitter:site" content={window.location.href} />
                        <meta name="twitter:title" content={this.props.newsDetails.article_title ? Parser(this.props.newsDetails.article_title) : ""} />
                        <meta name="twitter:description" content={ this.props.newsDetails.article_body && getFormattedTextForMeta(this.props.newsDetails.article_body, 1)} />
                        <meta name="twitter:image" content={API_URL + this.props.newsDetails.article_image} />
                    </Helmet>
                    <Spinner />
                    <ModalShare toggle={() => this.toggle()} openModal={this.state.openShareModal} className={"modalShare"} poster={API_URL + this.props.newsDetails.article_image}/>
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="w-100 p-3">
                                <div className="news-details-img">
                                    {
                                        this.props.newsDetails.article_category_id === 280 ?
                                          
                                                this.props.newsDetails.article_trailer ?
                                                    <div className="article-trailer">
                                                        <ReactPlayer controls={true} width='100%' height='100%' url={this.props.newsDetails.article_trailer} />
                                                    </div> :
                                                    <img width="100%" height="100%" src={this.props.newsDetails.article_image ? API_URL + Parser(this.props.newsDetails.article_image) : ""} alt={'News'} />
                                                
                                                :
                                        <img src={this.props.newsDetails.article_image ? API_URL + Parser(this.props.newsDetails.article_image) : ""} alt={'News'} />
                                    }

                                </div>
                                <div className="col-lg-12 clearfix p-2 filters-buttons">
                                    {this.getTags()}
                                </div>
                                <div className="col-lg-12 clearfix p-2">
                                    <h1 className="text-white article-title">{this.props.newsDetails.article_title}</h1>
                                    { this.isFavorite() }
                                </div>
                                <NewsAuthor
                                    image={this.props.newsDetails.article_author_picture}
                                    createdDate={this.props.newsDetails.article_created}
                                    name={this.getAuthorName()} />
                                {this.getAds()}
                                <div className="news-details-description" id="news-details" ref={ el => this.el = el }>
                                    { this.props.newsDetails.article_body !== undefined ? Parser(this.props.newsDetails.article_body.replace('alt=""','alt="News"')) : ''}
                                </div>
                                <Ads
                                    id="div-gpt-ad-1662463706379-0"
                                    slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463706379-0'); });"
                                />
                                <NewsAuthorBiography
                                    image={this.props.newsDetails.article_author_picture}
                                    name={this.getAuthorName()}
                                    biography={this.props.newsDetails.article_author_biography} />
                                <Comments
                                    comments={this.props.newsDetails.article_comments}
                                    commentsCount = {this.props.newsDetails.article_comment_count}
                                    articleId = {this.props.newsDetails.article_id}
                                    headline={this.state.commentsCount}
                                    className={'users'}
                                    showInput={true}
                                    addComment={this.addComment}
                                />
                            </div>
                        </div>
                        <div className="col-lg-3 w-10 p-3">
                            <AllnewsContainer />
                            <SearchByTag />
                        </div>
                    </div>
                </div>
                <div className="section-headline">
                    ARTICOLE RECOMANDATE PENTRU TINE
                </div>
                <div className="row">
                    <div className="col-12">
                        <NewsRecommendedForYou />
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests,
    newsDetails: state.news.newsDetails,
});

export default withRouter(connect(mapStateToProps,{getNewsDetails, addNewsToFavorite, removeNewsFromFavorite, addNewsComment})(NewsDetails));



// WEBPACK FOOTER //
// ./src/FO/components/newsdetails/newsdetails.component.js